import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Loader');
function Loader(_ref) {
  let {
    classes: classesProp,
    className,
    size = 'medium',
    color = 'primary'
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const rootClassName = classnames(className, classes.root, [classes[color]], [classes[size]]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName
  });
}
process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  color: PropTypes.oneOf(['primary', 'actionMinor', 'danger', 'white'])
} : void 0;
export default /*#__PURE__*/React.memo(Loader);